import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import * as moment from 'moment'

import CountryComponent from '../core/country/country.component'
import LocalStorageService from '../core/local-storage.service'
import Booking from '../core/models/booking'
import LanguageOption from '../core/models/language-option'
import Reservation from '../core/models/reservation'
import TranslateService from '../core/translate.service'
import CreditCardRegistrationService from '../credit-card-registration/credit-card-registration.services'

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export default class ConfirmationComponent extends CountryComponent implements OnInit {
  booking: Booking
  skipInsurances: boolean
  skipPayment: boolean
  languageOptions: LanguageOption
  isEltonModalOpen = false

  constructor(
    private router: Router,
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private creditCardRegistrationService: CreditCardRegistrationService
  ) {
    super(localStorageService)
  }

  get showElton(): boolean {
    if (!this.booking || !this.booking.reservation) {
      return false
    }

    const isElectric = this.isElectricCar(this.booking.reservation.car ?? null)
    const isNorway = this.pickupCountry === 'NORWAY' || this.pickupCountry === 'NO'

    return isNorway && isElectric
  }

  get showElectricGuide(): boolean {
    if (!this.booking || !this.booking.reservation) {
      return false
    }

    const isElectric = this.isElectricCar(this.booking.reservation.car ?? null)
    const isSweden = this.pickupCountry === 'SWEDEN' || this.pickupCountry === 'SE'

    return isSweden && isElectric
  }

  private get pickupCountry(): string | undefined {
    const pickupPlace = (this.booking as any)?.pickupPlace
    const pickupStation = (this.booking as any)?.pickupStation

    return pickupPlace?.country || pickupStation?.country
  }

  getSelectedLang(): string {
    return this.translate.currentLocaleOrDefault
  }

  ngOnInit(): void {
    this.localStorageService.removePaymentState()

    this.creditCardRegistrationService.setShowCreditCardNeeded(false)

    this.booking = this.localStorageService.getBooking()

    if (!this.booking) {
      this.router.navigate([])
    }

    this.translate.updateMomentLocale()
    const locale = this.translate.currentLocaleOrDefault
    moment.locale(locale)

    this.skipInsurances = this.localStorageService.getSkipInsurances()
    this.skipPayment = this.localStorageService.getSkipPayment()
    this.languageOptions = this.getLangOptions()
  }

  private isElectricCar(car: Reservation ['car'] | null): boolean {
    const carGroup = car?.carGroup
    if (!carGroup) {
      return false
    }

    const normalized = carGroup.trim().toUpperCase()
    if (normalized.length !== 3) {
      return false
    }

    return normalized.substring(1, 3) === '55'
  }
}
